

        <div class="con" style="width: 40rem;">
            <ngx-change-password [title]="'Wymagana zmiana hasła'" (changed)="close()" [open]="true"></ngx-change-password>
        </div>


